import { render, staticRenderFns } from "./SalaryEdit.vue?vue&type=template&id=0f8a1df0"
import script from "./SalaryEdit.vue?vue&type=script&lang=js"
export * from "./SalaryEdit.vue?vue&type=script&lang=js"
import style0 from "../../statics/css/cvpreview.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports